var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  AUTHORIZATION_TYPE = require('_js/constants/authorization'),
  Cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  filter = require('lodash/filter');
require('knockout-postbox');

function Oppdateringskalkulator(params) {
  var self = this;
  this.API = params.api;
  this.title = 'Progresjon etterutdanning';
  this.elements = ko.observableArray([]);
  this.extendedText = params.extendedText;
  this.isInSimpleCalculator = params.isInSimpleCalculator;
  this.oldPeriod = {};
  this.periodCounter = 0;
  this.isLoading = ko.observable(true);
  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  this.calculatorType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);
  this.calculatorType.subscribe(function() {
    self.getPeriodTotal();
    this.changeInAuthorizationType = true;
  });
  this.currentYear = ko.observable(0).subscribeTo('currentYearChange', true);
  this.startYear = ko.observable(0).subscribeTo('currentStartYear', true);
  this.endYear = ko.observable(0).subscribeTo('currentEndYear', true);
  this.dataSet = ko.observableArray([]);
  this.MAX_HOURS = ko.observable(80).syncWith('hoursRequirement');
  this.MAX_STRUCTURED_HOURS = ko
    .observable(60)
    .syncWith('hoursRequirementStructured');
  this.MAX_UNSTRUCTURED_HOURS = ko.observable(0);
  this.structuredHoursDone = ko
    .observable(0)
    .syncWith('totalStructuredHoursDone', true);
  this.unstructuredHoursDone = ko
    .observable(0)
    .syncWith('totalUnstructuredHoursDone', true);
  this.maxUnstructuredHoursDone = ko.computed(function() {
    return Math.min(
      this.MAX_UNSTRUCTURED_HOURS(),
      this.unstructuredHoursDone()
    );
  }, this);

  this.hoursPlanned = ko.observable(0).syncWith('totalHoursPlanned', true);
  this.hoursShopping = ko.observable(0).syncWith('totalHoursShopping', true);
  this.categories = ko.observableArray([]).syncWith('categories', true);
  this.hoursMissing = ko.computed(function() {
    var val = 0,
      shopping = 0;
    if (this.categories().length > 0) {
      for (var i = 0; i < this.categories().length; i++) {
        shopping += Math.max(0, this.categories()[i].Shopping());
      }
    } else {
      shopping = this.hoursShopping();
    }

    val =
      this.MAX_HOURS() -
      this.structuredHoursDone() -
      this.maxUnstructuredHoursDone() -
      this.hoursPlanned() -
      shopping;

    if (val < 0) {
      val = 0;
    }

    return val;
  }, this);
  this.changeInPeriod = ko.computed(function() {
    var val =
      this.MAX_HOURS() -
      this.MAX_STRUCTURED_HOURS() -
      this.MAX_UNSTRUCTURED_HOURS() -
      this.structuredHoursDone() -
      this.unstructuredHoursDone() -
      this.maxUnstructuredHoursDone() -
      this.hoursPlanned() -
      this.hoursShopping() -
      this.hoursMissing();
    return val;
  }, this);

  this.getPeriodTotal();
  this.currentYear.subscribe(function() {
    this.getPeriodTotal();
  }, this);

  this.startProgressBar();
  this.changeInPeriod.subscribe(function() {
    this.startProgressBar();
  }, this);

  // We have to use endYear as it is updated after startYear.
  this.endYear.subscribe(function() {
    this.updateShopping();
  }, this);

  ko.postbox.subscribe(
    'changeInPeriod',
    function() {
      this.startProgressBar();
    },
    this,
    true
  );

  ko.postbox.subscribe(
    'changeInAbsence',
    function() {
      this.getPeriodTotal();
    },
    this,
    true
  );
  ko.postbox.subscribe(
    'shoppingCartUpdated',
    function(newCart) {
      var courses = newCart.courses;
      if (courses.length > 0) {
        this.setHoursShopping(courses);
      } else {
        this.hoursShopping(0);
        this.categories().forEach(function(category) {
          category.Shopping(0);
        });
      }
    },
    this,
    true
  );
}

Oppdateringskalkulator.prototype.updateShopping = function() {
  var courses = Cart.getCart().courses;
  if (courses.length > 0) {
    this.setHoursShopping(courses);
  } else {
    this.hoursShopping(0);
    this.categories().forEach(function(category) {
      category.Shopping(0);
    });
  }
};

Oppdateringskalkulator.prototype.setHoursShopping = function(courses) {
  var hours = 0;
  this.categories().forEach(function(category) {
    category.Shopping(0);
  });
  courses.forEach(
    function(course) {
      var year;
      // Check if date is defined. If it is not, we'll just set it to the current year.
      if (course.Date === undefined || course.Date === null) {
        year = new Date().getFullYear();
      } else {
        year = new Date(course.Date).getFullYear();
      }
      // We only want to update this component if the course year is equal to this year.
      if (year >= this.startYear() && year <= this.endYear()) {
        var filteredCredits = filter(course.AuthorizationCredits, {
          AuthorizationType: this.calculatorType()
        });
        filteredCredits.forEach(
          function(credit) {
            hours += parseFloat(credit.Hours, 10);
            var category = ko.utils.arrayFirst(this.categories(), function(
              item
            ) {
              return item.CategoryKey == credit.CategoryKey;
            });
            if (category && category != null) {
              category.Shopping(category.Shopping() + credit.Hours);
            }
          }.bind(this)
        );
      }
    }.bind(this)
  );

  this.hoursShopping(hours);
};

Oppdateringskalkulator.prototype.getPeriodTotal = function() {
  var url =
    this.API.periodTotal +
    '?authorizationType=' +
    encodeURIComponent(this.calculatorType());

  if (this.currentYear() !== 0) {
    url = url + '&startYear=' + encodeURIComponent(this.currentYear());
  }

  ko.postbox.publish('periodYearsLoading', true);
  APIHelper.get(
    url,
    function(response) {
      var maxUnstructuredHoursDone =
        response.Requirement - response.RequirementStructured;
      this.isLoading(false);
      this.structuredHoursDone(response.TotalStructuredHoursDone);
      this.unstructuredHoursDone(response.TotalUnstructuredHoursDone);
      this.hoursPlanned(response.TotalHoursPlanned);
      this.MAX_HOURS(response.Requirement);
      this.MAX_STRUCTURED_HOURS(response.RequirementStructured);
      this.MAX_UNSTRUCTURED_HOURS(maxUnstructuredHoursDone);
      ko.postbox.publish('requirementHoursFromMainCategories', response.RequirementHoursMainCategories);
      ko.postbox.publish('hoursFromMainCategories', response.TotalHoursFromMainCategories);
      ko.postbox.publish('requirementHoursPerMainCategoryCovered', response.RequirementPerMainCategoryCovered);
      ko.postbox.publish('requirementHoursFromMainCategoriesCovered', response.RequirementMainCategoriesCovered);
      ko.postbox.publish('maxRequiredHours', response.Requirement);
      
      if (response.YearTotals.length > 0) {
        ko.postbox.publish('currentStartYear', response.YearTotals[0].Year);
        ko.postbox.publish(
          'currentEndYear',
          response.YearTotals[response.YearTotals.length - 1].Year
        );
        ko.postbox.publish(
          'totalHoursDoneWithUnstructured',
          response.TotalHoursDone
        );
        // See if the period has changed and in that case report the change.
        if (JSON.stringify(response) !== JSON.stringify(this.oldPeriod)) {
          ko.postbox.publish('changeInPeriod', ++this.periodCounter);
        }
        // Subscribers: calculator-years
        ko.postbox.publish('periodYears', response.YearTotals);
      }
      ko.postbox.publish('periodYearsLoading', false);
      this.oldPeriod = response;
    }.bind(this),
    function(response) {
      this.isLoading(false);
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: calculator-donut.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

Oppdateringskalkulator.prototype.startProgressBar = function() {
  var self = this;
  this.dataSet(this.createDataSet());
  this.elements = ko.computed(function() {
    return self
      .dataSet()
      .map(function(item) {
        if (item.hours === 0 && item.typeNumber === 4) return null;

        var percent = (item.hours / self.MAX_HOURS()) * 100;
        var color = item.color;

        return {
          title: item.title,
          color: color,
          style: {
            backgroundColor: color,
            width: percent + '%'
          },
          hours: item.hours,
          type: item.typeNumber
        };
      })
      .filter(Boolean);
  });
};

Oppdateringskalkulator.prototype.createDataSet = function() {
  var data = null;
  data = [
    {
      title: 'Gjennomførte kurstimer',
      hours: this.structuredHoursDone(),
      type: 'completed',
      color: '#32CBCB',
      typeNumber: 0
    },
    {
      title: 'Ikke-strukturerte timer',
      hours: this.maxUnstructuredHoursDone(),
      type: 'doneUnstructured',
      color: '#0098CB',
      typeNumber: 4
    },
    {
      title: 'Påmeldte timer',
      hours: this.hoursPlanned(),
      type: 'registered',
      color: '#FF6532',
      typeNumber: 1
    },
    {
      title: 'Timer i handlekurven',
      hours: this.hoursShopping(),
      type: 'inShoppingCart',
      color: '#FECB2F',
      typeNumber: 2
    },
    {
      title: 'Manglende timer',
      hours: this.hoursMissing(),
      type: 'missing',
      color: '#CBCBCB',
      typeNumber: 3
    }
  ];

  return data;
};

module.exports = Oppdateringskalkulator;
